import React from 'react';

const Heading = ({ level, children, ...rest }) => {
    const HeadingTag = `h${level}`;

    return (
        <HeadingTag {...rest}>
            {children}
        </HeadingTag>
    );
};

export {Heading};
